// extracted by mini-css-extract-plugin
export default {"title":"components-Editorials-editorialTitle__title--_9ZBQ"};